import { create } from 'zustand';

export const lobbyId = 'lobby';
export const liveId = 'live';

// league tiles keep the bare league id; sport and competition ids come from other BE tables and would collide with it
const SPORT_TILE_PREFIX = 'sport:';
const COMPETITION_TILE_PREFIX = 'competition:';

export const sportTileId = (sportId: string) => `${SPORT_TILE_PREFIX}${sportId}`;
export const competitionTileId = (competitionId: string) => `${COMPETITION_TILE_PREFIX}${competitionId}`;

export type TileType = 'lobby' | 'live' | string;

export const leagueIdFromTile = (tile: TileType) => {
    if (
        tile === lobbyId ||
        tile === liveId ||
        tile.startsWith(SPORT_TILE_PREFIX) ||
        tile.startsWith(COMPETITION_TILE_PREFIX)
    ) {
        return undefined;
    }
    return tile;
};

export interface SbkLobbySectionSelection {
    selectedTile: TileType;
    selectedSubGroupId: string | undefined;
    eventId: string | undefined;
    actions: {
        setSelectedTile: (league: TileType) => void;
        setSelectedSubGroup: (subGroupId: string) => void;
    };
}

export const useSbkLobbySectionSelection = create<SbkLobbySectionSelection>()((set, get) => ({
    selectedTile: lobbyId,
    selectedSubGroupId: undefined,
    eventId: undefined,
    actions: {
        // also called with the current tile on every route param sync, which must not reset the chip
        setSelectedTile: (tile: TileType) => {
            if (get().selectedTile === tile) {
                return;
            }
            set({ selectedTile: tile, selectedSubGroupId: undefined });
        },
        setSelectedSubGroup: (subGroupId: string) => {
            set({ selectedSubGroupId: subGroupId });
        },
    },
}));
